import Call from '../Call.v3';

import qs from 'querystring';

const AdkPartnerDomainReplacementLog = {
    get: async (filters = {}) => Call(`adk/partner_domain_replacement_log?${qs.stringify(filters)}`),
};

export default AdkPartnerDomainReplacementLog;



// WEBPACK FOOTER //
// ./src/services/API/components/AdkPartnerDomainReplacementLog.js